import apiFetch from '../apiFetch'

export default function (token, income) {
  return apiFetch({ endPoint: 'PaperworkType/Master/Update', method: 'PUT', body: income, token: token })
}
